import React from 'react';
import PersonImageModal from '../person-image-modal/PersonImageModal';
import BackgroundModal from '../background-modal/BackgroundModal';
import BulkDeleteModal from '../bulk-delete-modal/BulkDeleteModal';
import AddToClosetModal from '../add-to-closet-modal/AddToClosetModal';
import VTOLoginConfirmationPortal from '../virtual-try-on/VTOLoginConfirmationPortal';
import ClothingModal from '../clothing-modal/ClothingModal';

/**
 * Component to render all MyCloset modals
 * Extracted from MyCloset.js to reduce file size
 */
const MyClosetModals = ({
    // Person Image Modal props
    isPersonImageModalOpen,
    onPersonImageModalClose,
    currentPersonImageUrl,

    // Background Modal props
    isBackgroundModalOpen,
    onBackgroundModalClose,
    currentBackground,
    onBackgroundChange,
    onBackgroundUpload,

    // Login Modal props
    isLoginModalOpen,
    onLoginModalClose,
    onLoginRedirect,

    // VTO Login Modal props
    isVTOLoginModalOpen,
    onVTOLogin,
    hideVTOLoginModal,

    // Bulk Delete Modal props
    isBulkDeleteModalOpen,
    setBulkDeleteModalOpen,
    selectedItems,
    onBulkDeleteSuccess,

    // Add to Closet Modal props
    isAddToClosetModalOpen,
    setAddToClosetModalOpen,
    onAddToClosetSuccess,

    // Clothing Modal props
    isClothingModalOpen,
    editClothingItemId,
    onCloseClothingModal
}) => {
    return (
        <>
            {/* Person Image Modal */}
            <PersonImageModal
                isOpen={isPersonImageModalOpen}
                onClose={onPersonImageModalClose}
                currentPersonImage={currentPersonImageUrl}
            />

            {/* Background Modal */}
            <BackgroundModal
                isOpen={isBackgroundModalOpen}
                onClose={onBackgroundModalClose}
                currentBackground={currentBackground}
                onBackgroundChange={onBackgroundChange}
                onImageUpload={onBackgroundUpload}
            />

            {/* Login Confirmation Modal */}
            <VTOLoginConfirmationPortal
                isOpen={isLoginModalOpen}
                onClose={onLoginModalClose}
                onLogin={onLoginRedirect}
                onCancel={onLoginModalClose}
            />

            {/* Bulk Delete Confirmation Modal */}
            <BulkDeleteModal
                isOpen={isBulkDeleteModalOpen}
                onClose={() => setBulkDeleteModalOpen(false)}
                selectedIds={selectedItems}
                onDeleteSuccess={onBulkDeleteSuccess}
            />

            {/* Add to Closet Modal */}
            <AddToClosetModal
                open={isAddToClosetModalOpen}
                onClose={() => setAddToClosetModalOpen(false)}
                selectedItemIds={selectedItems}
                onSuccess={onAddToClosetSuccess}
            />

            {/* VTO Login Confirmation Portal */}
            <VTOLoginConfirmationPortal
                isOpen={isVTOLoginModalOpen}
                onLogin={onVTOLogin}
                onCancel={hideVTOLoginModal}
                onClose={hideVTOLoginModal}
            />

            {/* Clothing Modal */}
            <ClothingModal
                isOpen={isClothingModalOpen}
                onClose={onCloseClothingModal}
                editItemId={editClothingItemId}
            />
        </>
    );
};

export default MyClosetModals;
